/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import AddressBook from './AddressBook';
import GuestPromoCode from './RecipientBook/Common/GuestPromoCode';
import RecipientBookContainer from './RecipientBook/RecipientBookContainer';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const AddressBookContainer = () => {
    const isRecipientBookEnabled = useSelector(getFeatureFlag('is-recipient-book-enabled'));
    const isGuestStartedOfferEnabled = useSelector(getFeatureFlag('is-guest-started-offer-enabled'));

    return (
        <>
            {isGuestStartedOfferEnabled ? <GuestPromoCode /> : ''}
            {isRecipientBookEnabled
                ? (<RecipientBookContainer />)
                : (<AddressBook />)}
        </>
    );
};

export default AddressBookContainer;
